import React from "react"
import "./index.css"

const DashboardCardHeader = props => (
  <div className={"dashboard-card-header"}>
    {props.icon && <img src={props.icon} alt={props.children} />}
    <p>{props.children}</p>
  </div>
)

export default DashboardCardHeader



// WEBPACK FOOTER //
// ./src/components/dashboard-card-header/DashboardCardHeader.js